import { QueryClient, useMutation } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import removeEmpty from '../../../utils/removeEmptyValuesFromObject';

const editPOQuery = (data) => {
    const cleanedData = removeEmpty(data);
    return axios.put(apiurl?.editPO, cleanedData);
};

const editPO = () => {
    const queryClient = new QueryClient();
    return useMutation(['editPO'], editPOQuery, {
        onSuccess: () => {
            queryClient.invalidateQueries('getPOList');
        }
    });
};

export default editPO;
